import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PochtaTariffDimensionWrite
*  Габариты для калькулятора (`dimension` в теле `/1.0/tariff`).
*/
export class PochtaTariffDimensionWrite extends ActiveModel {

  /**
  * height
  *   */
  @ActiveField()
  height?: null | number


  /**
  * length
  *   */
  @ActiveField()
  length?: null | number


  /**
  * width
  *   */
  @ActiveField()
  width?: null | number
}
